/**
 * We allow users in Kontent.ai to pass values into our codebase.
 * Some of our previous features are poorly designed, and allowed
 * a user to provide a src URL which would then be loaded in as a script,
 * leading to code injection. This error should be thrown to prevent those cases from occurring.
 *
 * @example
 * ```
 * const requiredHostname = 'brands.click2buy.com'
 * const url = new URL(srcUrl)
 * if (srcUrl && url.hostname !== requiredHostname) {
 * 	logError(new AttemptedCodeInjectionError(srcUrl, requiredHostname))
 * 	return null
 * }
 * ```
 */
export class AttemptedCodeInjectionError extends Error {
	constructor(src: string, subdomain: string) {
		super(
			`Attempted code injection: User provided "${src}", which is not on expected subdomain "${subdomain}"`
		)
		this.name = 'AttemptedCodeInjectionError'
	}
}
